<template>

      <div class="container is-fullhd template-horizontal">
        <TheSidebar/>
        <router-view/>
      </div>

</template>

<script>

  import TheSidebar from '../pages/TheNotice'

    export default {
      components:{ TheSidebar},
      data() {
        return {

        }
      },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Public.vue